import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { AngularModalService } from './modal.service';
import { CompanyPageChangeCompanyStateModalComponent } from 'src/app/pages/mission-control-page/company-page/company-page-change-company-state-modal/company-page-change-company-state-modal.component';

// Downgraded (see service.module.ajs.js) so the still-AngularJS
// company-page.component.js root controller (native port not due until
// build step 10) can open this native modal in place of its old
// `this.$uibModal.open({component: 'changeCompanyStateModal', ...})` call.
@Injectable({
  providedIn: 'root'
})
export class CompanyPageChangeCompanyStateModalService {

  changeCompanyStateModal!: BsModalRef;

  constructor(private bsModalService: BsModalService, private angularModalService: AngularModalService) { }

  show(initialState: { companyInfo: any; changeToState: string }, onResult: (callbackObject: any) => void): void {
    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-medium';
    config.ignoreBackdropClick = true;
    config.initialState = initialState;
    this.changeCompanyStateModal = this.bsModalService.show(CompanyPageChangeCompanyStateModalComponent, config);
    this.changeCompanyStateModal.content.onClose.subscribe((callbackObject: any) => {
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      onResult(callbackObject);
    });
  }
}
